module.exports = __webpack_public_path__ + "Zee404___1-Nal.png";